module.exports = __webpack_public_path__ + "img/2-a-4-Completed mould.6423fdf5.jpg";